import request from '@/request';

export function getAiOpsTokens() {
  return request.get('/aiops/admin/tokens');
}

export function createAiOpsToken(payload) {
  return request.post('/aiops/admin/tokens', payload);
}

export function updateAiOpsToken(tokenId, payload) {
  return request.put(`/aiops/admin/tokens/${tokenId}`, payload);
}

export function deleteAiOpsToken(tokenId) {
  return request.delete(`/aiops/admin/tokens/${tokenId}`);
}

export function updateAiOpsTokenEnabled(tokenId, enabled) {
  return request.patch(`/aiops/admin/tokens/${tokenId}/enabled`, { enabled });
}

export function getAiOpsPresets() {
  return request.get('/aiops/admin/presets');
}

export function createAiOpsPreset(payload) {
  return request.post('/aiops/admin/presets', payload);
}

export function updateAiOpsPreset(presetId, payload) {
  return request.put(`/aiops/admin/presets/${presetId}`, payload);
}

export function deleteAiOpsPreset(presetId) {
  return request.delete(`/aiops/admin/presets/${presetId}`);
}

export function getAiOpsPresetBindings(presetId) {
  return request.get(`/aiops/admin/presets/${presetId}/application-bindings`);
}

export function saveAiOpsPresetBindings(presetId, appEnvIds) {
  return request.put(`/aiops/admin/presets/${presetId}/application-bindings`, { appEnvIds });
}

export function getAppEnvironments() {
  return request.get('/app/environments');
}
